import { createInstance } from 'i18next';

function i18n({
  locale,
  localeResource
}) {
  const newInstance = createInstance();
  return newInstance.init({
    lng: locale,
    keySeparator: "$",
    interpolation: {
      escapeValue: false
    },
    react: {
      wait: true
    },
    resources: {
      [locale]: { translation: localeResource }
    }
  });
}

export { i18n as default };
//# sourceMappingURL=i18n.js.map
